const styles = theme => ({
  container: {
    // padding: 4,
    maxWidth: '46.375rem',
    margin: '0 auto',
    textAlign: 'center',
  },
  heading: {
    textAlign: 'center',
    marginBottom: '2rem',
    color: theme.palette.primary.textColor3,
  },
  handsetContainer: {
    maxWidth: '32.6rem',
    margin: '0 auto',
  },
  handsetHeading: {
    marginBottom: '0.5rem',
    color: theme.palette.primary.textColor3,
  },
  option: {
    border: `1px solid ${theme.palette.primary.textColor5}`,
    padding: '0.5rem',
    cursor: 'pointer',
    borderRadius: '0.25rem',
    color: theme.palette.primary.backgroundColor2,
    width: '100%',
  },
  optionContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
  },
  buttonIcon: {
    width: '1.875rem',
    height: '1.875rem',
    color: 'inherit',
  },
  inlineIcon: {
    marginTop: '0.25rem',
  },
  textContainer: {
    flex: 1,
    textAlign: 'left',
  },
  buttonTitle: {
    color: theme.palette.primary.textColor3,
    marginBottom: '0.25rem',
  },
  buttonDescription: {
    color: theme.palette.primary.textColor3,
  },
  selected: {
    borderColor: theme.palette.primary.textColor5,
    backgroundColor: theme.palette.primary.textColor3,
  },
  selectedText: {
    color: theme.palette.primary.backgroundColor3,
  },

  brandContainer: {
    maxWidth: '46.375rem',
    margin: '0 auto',
    padding: '1.5rem 0 0 0',
  },
  description: {
    marginBottom: '2rem',
    color: theme.palette.primary.textColor3,
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  checkoutFieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  select: {
    width: '13.75rem',
    height: '2.5rem',
    '& .MuiSelect-icon': {
      width: '24px',
      height: '24px',
      color: theme.palette.primary.buttonColor,
    },
    '& label.Mui-focused': {
      color: theme.palette.primary.buttonColor,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.buttonColor,
      },
    },
  },
  eidBox: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },

  eidToolIcon: {
    width: '16px',
    height: '16px',
    fontSize: '16px',
  },
  eidInput: {
    width: '100%',
    '& label.Mui-focused': {
      color: theme.palette.primary.buttonColor,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.buttonColor,
      },
    },
  },
  notice: {
    maxWidth: '474px',
    paddingLeft: '0.875rem',
    color: theme.palette.primary.textColor5,
  },
  confirmCTA: {
    border: `0.1875rem solid ${theme.palette.primary.buttonColor}`,
    width: '12rem',
    padding: '0.3125rem',

    minHeight: '2.5rem',
    color: theme.palette.secondary.contrastText,
    background: theme.palette.primary.buttonColor,
    '&:hover': {
      border: `0.1875rem solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 2px 4px -1px  ${theme.palette.primary.boxShadow}, 0px 4px 5px  ${theme.palette.primary.boxShadow}, 0px 1px 10px  ${theme.palette.primary.boxShadow}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0.5rem',
    },
  },
  confirmCTADisabled: {
    background: theme.palette.primary.buttonInactiveColor,
    width: '12rem',
    padding: '0.3125rem',
    pointerEvents: 'none',
    minHeight: '2.5rem',
    color: theme.palette.secondary.contrastText,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0.5rem',
    },
  },
  continueCtaContainer: {
    display: 'flex',
    justifyContent: 'center',
    pl: '1rem',
    mt: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      pl: '1.8rem',
      pr: '1.8rem',
      mt: '2.5rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      pl: '2.6rem',
      pr: '1.8rem',
      mt: '2.5rem',
      mb: 0,
      textAlign: 'center',
    },
  },
  checkoutSimContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  SimText: {
    color: theme.palette.primary.textColor5,
  },
  iconButton: {
    width: '16px',
    height: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  vectorIcon: {
    width: '13.33px',
    height: '13.33px',
  },
  link: {
    color: theme.palette.primary.buttonColor,
    textDecoration: 'underline',
    cursor: 'pointer',
    textDecorationSkipInk: 'none',
  },

  modalWrapper: {
    backdropFilter: 'blur(8px)', // Blur background
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  modalPaper: {
    width: '634px',
    height: '428px',
    padding: '12px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: '10px',
    opacity: 1,
    transform: 'rotate(0deg)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '344px',
      height: '633px',
    },
  },

  title: {
    textAlign: 'center',
    color: theme.palette.primary.textColor3,
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '0 20px 28px 20px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 12px 0 12px',
    },
  },
  headingText: {
    color: theme.palette.primary.textColor3,
    marginBottom: '8px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
    },
  },
  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '0 32px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 8px',
    },
    gap: '5px',
  },
  icon: {
    width: '30px',
    height: '30px',
    color: theme.palette.primary.sunset,
  },
  inlineHeading: {
    marginRight: '4px',
    color: theme.palette.primary.textColor3,
  },
  descriptionText: {
    color: theme.palette.primary.textColor3,
  },

  closeButton: {
    position: 'absolute',
    top: '9px',
    right: '9px',
    color: theme.palette.primary.buttonColor,
    zIndex: 1,
    display: { xs: 'none', sm: 'block', md: 'block' },
  },
  mobileButton: {
    mt: '1rem',
    width: '100%',
    color: theme.palette.primary.backgroundColor2,
    backgroundColor: theme.palette.primary.buttonColor,
    display: { xs: 'block', sm: 'none', md: 'none' },
  },
});

export default styles;
